import axios from 'axios';
import * as qs from 'qs';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction, IPayload } from 'react-jhipster';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, ITableType } from 'app/shared/model/commission-userment.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { cleanEntity } from 'app/shared/util/entity-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_REPORTMENT_LIST: 'userment/FETCH_REPORTMENT_LIST', // 列表
  FETCH_USER: 'userment/FETCH_USER',
  CREATE_USER: 'userment/CREATE_USER',
  UPDATE_USER: 'userment/UPDATE_USER',
  DELETE_USER: 'userment/DELETE_USER',
  CLEAR_USER: 'userment/CLEAR_USER',
  RESET: 'userment/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITableType>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  status: null
};

export type cUsermentState = Readonly<typeof initialState>;

// Reducer
export default (state: cUsermentState = initialState, action): cUsermentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REPORTMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_USER):
    case REQUEST(ACTION_TYPES.CREATE_USER):
    case REQUEST(ACTION_TYPES.UPDATE_USER):
    case REQUEST(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case FAILURE(ACTION_TYPES.FETCH_REPORTMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_USER):
    case FAILURE(ACTION_TYPES.CREATE_USER):
    case FAILURE(ACTION_TYPES.UPDATE_USER):
    case FAILURE(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
        status: action.payload.status
      };
    case SUCCESS(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      const newList = action.payload.data.content || [];
      newList.forEach(item => {
        const nameList = ['全民用户', '中介', '管家', '中介管理者'];
        item.typeName = nameList[item.type];
      });
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: newList || [],
        totalItems: parseInt(action.payload.data['totalElements'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_USER):
    case SUCCESS(ACTION_TYPES.CREATE_USER):
    case SUCCESS(ACTION_TYPES.UPDATE_USER):
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        entity: action.payload.data,
        status: action.payload.status
      };
    case SUCCESS(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: defaultValue
      };
    case ACTION_TYPES.CLEAR_USER:
      return {
        ...state,
        entity: defaultValue
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = '/fy/user'; //
// 列表
export const getEntities: ICrudGetListAction<ITableType> = (page, size, sort = '', searchForm) => {
  const requestUrl = `${apiUrl}/list${page ? `?page=${page}&size=${size}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_REPORTMENT_LIST,
    payload: axios.get<ITableType>(`${requestUrl}`, {
      params: searchForm,
      paramsSerializer: params => qs.stringify(params)
    }),
    meta: { transformUserName: true }
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

// // 创建
// export function createInfo(entity) {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(`${apiUrl}/save`, cleanEntity(entity))
//       .then(response => {
//         resolve(response.data);
//       })
//       .catch(() => {
//         reject();
//       });
//   });
// }
// // 更新
// export function updateInfo(entity) {
//   return new Promise((resolve, reject) => {
//     axios
//       .put(`${apiUrl}/update`, cleanEntity(entity))
//       .then(response => {
//         resolve(response.data);
//       })
//       .catch(() => {
//         reject();
//       });
//   });
// }

export const createInfo: ICrudPutAction<ITableType> = user => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_USER,
    payload: axios.post(`${apiUrl}/save`, user)
  });
  // dispatch(getEntities());
  return result;
};

export const updateInfo: ICrudPutAction<ITableType> = (user?: any) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.put(`${apiUrl}/update`, user)
  });
  // dispatch(getEntities());
  return result;
};

export const deleteUser: ICrudDeleteAction<ITableType> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/delete`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_USER,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const clearUser = () => ({
  type: ACTION_TYPES.CLEAR_USER
});

// 详情
export const getUser: ICrudGetAction<ITableType> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_USER,
    payload: axios.get<ITableType>(requestUrl)
  };
};
